export class Action {
    id: number;
    description: string;
    checked: boolean;
}
